<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">操作日志查询</h2>
      </div>
      <div class="life-filter">
        <el-input v-model="filters.plateNo" placeholder="码牌编号" clearable style="width: 180px" @keyup.enter.native="search" />
        <el-input v-model="filters.operatorName" placeholder="操作人" clearable style="width: 150px" @keyup.enter.native="search" />
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">日志列表</h2>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="plateNo" label="码牌编号" width="150" />
        <el-table-column prop="operationName" label="操作" width="100" />
        <el-table-column prop="operatorName" label="操作人" width="120" />
        <el-table-column prop="changeReason" label="原因" min-width="180" />
        <el-table-column prop="createTime" label="操作时间" width="170" />
      </el-table>
      <el-pagination class="life-pagination" :current-page.sync="page.current" :page-size="page.size"
        :page-sizes="[10, 20, 50]" :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="changeSize" @current-change="load" />
    </section>
  </div>
</template>

<script>
import { listOperationLogs } from '@/api/aggregateCode/aggregateCodeApi'

export default {
  name: 'AggregateCodeOperationLogList',
  data() {
    return {
      loading: false, rows: [],
      filters: { plateNo: '', operatorName: '' },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listOperationLogs({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = Number(res.total || 0)
      } catch (error) {
        this.$message.error(error.message || '加载操作日志失败')
      } finally { this.loading = false }
    },
    search() { this.page.current = 1; this.load() },
    reset() { this.filters = { plateNo: '', operatorName: '' }; this.search() },
    changeSize(size) { this.page.size = size; this.load() }
  }
}
</script>

<style lang="scss" scoped>
@import './life.scss';
</style>
